module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "speaker"
  }, [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deleteClubSpeaker(_vm.speaker.id)
      }
    }
  }), _vm._v(" "), (!_vm.speaker.photo) ? _c('div', {
    staticClass: "rounded-photo-wrapper centered speaker-photo",
    on: {
      "click": function($event) {
        return _vm.handleLoadSpeakerPhoto(_vm.speaker.id)
      }
    }
  }, [_c('span', [_vm._v("Сменить фото")])]) : _c('div', {
    staticClass: "speaker-photo",
    style: (_vm.photoStyle),
    on: {
      "click": _vm.deletePhoto
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Имя фамилия"
    },
    on: {
      "change": _vm.handleUpdateSpeaker
    },
    model: {
      value: (_vm.speaker.name),
      callback: function($$v) {
        _vm.$set(_vm.speaker, "name", $$v)
      },
      expression: "speaker.name"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    on: {
      "change": _vm.handleUpdateSpeaker
    }
  }, [_c('b-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "Должность, какую компанию представляет"
    },
    on: {
      "change": _vm.handleUpdateSpeaker
    },
    model: {
      value: (_vm.speaker.post),
      callback: function($$v) {
        _vm.$set(_vm.speaker, "post", $$v)
      },
      expression: "speaker.post"
    }
  })], 1), _vm._v(" "), _c('input', {
    ref: "loadPhotoButton",
    attrs: {
      "type": "file",
      "id": "photo",
      "hidden": ""
    },
    on: {
      "change": _vm.loadPhoto
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "is-hidden delete-photo centered"
  }, [_c('span', [_vm._v("\n        Удалить фото\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e840895"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Events/ClubSpeaker.vue
// module id = 976
// module chunks = 0